var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: _vm.transition } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "weui-loading_toast vux-loading",
        class: !_vm.text ? "vux-loading-no-text" : ""
      },
      [
        _c("div", { staticClass: "weui-mask_transparent" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "weui-toast",
            style: {
              position: _vm.position
            }
          },
          [
            _c("i", { staticClass: "weui-loading weui-icon_toast" }),
            _vm._v(" "),
            _vm.text
              ? _c(
                  "p",
                  { staticClass: "weui-toast__content" },
                  [_vm._v(_vm._s(_vm.text || "加载中")), _vm._t("default")],
                  2
                )
              : _vm._e()
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1adbd40e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1adbd40e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
// module id = null
// module chunks = 